var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.25 9.75V21H51.75V7.5C51.75 7.0858 51.4142 6.75 51 6.75H7.5C7.08582 6.75 6.75 7.08581 6.75 7.5V64.5C6.75 64.9142 7.08583 65.25 7.5 65.25H36V63.75H9.75H8.25V62.25V9.75V8.25H9.75H48.75H50.25V9.75Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.75 22.5C66.75 21.2574 65.7426 20.25 64.5 20.25H37.5C36.2574 20.25 35.25 21.2574 35.25 22.5V64.5C35.25 65.7426 36.2574 66.75 37.5 66.75H64.5C65.7426 66.75 66.75 65.7426 66.75 64.5V22.5ZM62.25 24.75V62.25H39.75V24.75H62.25Z",
    fill: "#F30002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.75 55.5C54.75 54.2574 53.7426 53.25 52.5 53.25H49.5C48.2574 53.25 47.25 54.2574 47.25 55.5C47.25 56.7426 48.2574 57.75 49.5 57.75H52.5C53.7426 57.75 54.75 56.7426 54.75 55.5Z",
    fill: "#F30002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 55.5C30.75 55.0858 30.4142 54.75 30 54.75H27C26.5858 54.75 26.25 55.0858 26.25 55.5C26.25 55.9142 26.5858 56.25 27 56.25H30C30.4142 56.25 30.75 55.9142 30.75 55.5Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.00a2b0aca773ddf65224f14a30c8e6ed.svg";
export { ForwardRef as ReactComponent };